import { render } from "./companies.vue?vue&type=template&id=53acd59d&scoped=true"
import script from "./companies.vue?vue&type=script&lang=js"
export * from "./companies.vue?vue&type=script&lang=js"

import "./companies.vue?vue&type=style&index=0&id=53acd59d&scoped=true&lang=css"

import exportComponent from "D:\\Web\\hkjt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53acd59d"]])

export default __exports__